import { TradeIdeasBadge, BadgeProps } from './TradeIdeasBadge';
import { EmptyList, EmptyStateProps, LoadingState } from './utils';
import { PortfolioSectionHeader } from '../PortfolioSectionHeader';
import { PORTFOLIO_CARD_CLASSNAME } from '../portfolioLayoutConstants';
import { widgetBodyClassName, widgetTitleClassName } from '../../../../edge/dashboard/_components/widgetChrome';

export const WatchlistNewsFeed = ({
  badge,
  title,
  children,
  isLoading,
  newsCount,
  embedded = false,
  hideTitle = false,
  skeleton,
  subtitle,
  emptyMessage,
  emptyState,
  emptyMinHeightClass,
}: {
  badge?: BadgeProps;
  title: string;
  children: React.ReactNode;
  isLoading: boolean;
  newsCount: number;
  embedded?: boolean;
  hideTitle?: boolean;
  skeleton?: React.ReactNode;
  subtitle?: string;
  emptyMessage?: string;
  emptyState?: EmptyStateProps;
  emptyMinHeightClass?: string;
}) => {
  const body = (
    <div
      className={`relative flex flex-1 flex-col ${
        embedded ? 'min-h-[80px]' : 'min-h-[120px]'
      }`}
    >
      {isLoading && newsCount === 0 ? (
        (skeleton ?? <LoadingState />)
      ) : (
        <div
          className={`transition-opacity duration-150 ease-out ${isLoading ? 'opacity-60' : 'opacity-100'}`}
        >
          {children}
        </div>
      )}
      {!isLoading && newsCount === 0 ? (
        <EmptyList
          compact={embedded}
          message={emptyMessage}
          minHeightClass={emptyMinHeightClass}
          {...emptyState}
        />
      ) : null}
    </div>
  );

  if (embedded) {
    return (
      <div className="flex flex-1 flex-col">
        {!hideTitle && (
          <div className="mb-3 flex flex-wrap items-center gap-2">
            <h3 className={widgetTitleClassName}>{title}</h3>
            {badge && <TradeIdeasBadge badge={badge} />}
          </div>
        )}
        {body}
      </div>
    );
  }

  return (
    <section className={PORTFOLIO_CARD_CLASSNAME}>
      <PortfolioSectionHeader
        title={title}
        subtitle={subtitle}
        titleAddon={badge ? <TradeIdeasBadge badge={badge} /> : null}
      />
      <div className={widgetBodyClassName}>{body}</div>
    </section>
  );
};
